import { EVENT_COLL } from "../util/CommonConstants";
import Fire from "./Fire";
import { createRandomId } from "../util/Util";

var collectionName = EVENT_COLL;

class EventColl {
  async getFirebaseDatabase() {
    return Fire.shared.getDatabase();
  }

  async getUnapprovedEvents() {
    let db = await this.getFirebaseDatabase();

    if (!db) {
      return false;
    }

    try {
      let results = null;

      console.log(collectionName + "_unapproved");
      results = await db.collection(collectionName + "_unapproved").get();

      if (results) {
        return Fire.shared.getDataArray(results);
      }

      return [];
    } catch ({ message }) {
      console.log("Failed to get events");
      console.log(message);
      return [];
    }
  }

  async deleteUnapprovedEvent(id) {
    let db = await this.getFirebaseDatabase();

    if (!db) {
      return false;
    }

    let resp = await Fire.shared.deleteSingleDocumentById(
      id,
      collectionName + "_unapproved"
    );
    return resp;
  }

  async createEvent(event, approved = false) {
    if (!event) {
      return false;
    }

    try {
      if (!event.id) {
        let siteName = event.title.replace(/\//g, "");
        let siteId = siteName.replace(/\s/g, "").substring(0, 10);

        event.id = siteId + "_" + createRandomId();
      }

      if (!event.rsvp_list) {
        event.rsvp_list = [];
      }
    } catch (error) {
      console.log(error);
      return false;
    }

    let approvedCollName = collectionName;
    if (!approved) approvedCollName = collectionName + "_unapproved";

    try {
      var response = await Fire.shared.createSingleDocumentById(
        event,
        approvedCollName
      );

      if (response === true) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      console.error(e);
      return false;
    }
  }
}

EventColl.shared = new EventColl();

export default EventColl;
